import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login';
import mainView from '@/views/mainView';
import userMaintenance from '@/views/userMaintenance/userMaintenance';
import roleMaintenance from '@/views/roleMaintenance/roleMaintenance';
import auditLog from '@/views/auditLog/auditLog';
import unenabled from '@/views/unenabled';
import changePassword from '@/views/changePassword/changePassword';

import userEdit from '@/views/userMaintenance/userEdit';
import addUser from '@/views/userMaintenance/addUser';
import addRole from '@/views/roleMaintenance/addRole';
import roleEdit from '@/views/roleMaintenance/roleEdit';

import managerRouters from './manager-report';
import recordRouters from './record';
import reportRouters from './report';

// V3.1.0版本里面新增功能：push和replace方法会返回一个promise, 你可能在控制台看到未捕获的异常
// 虽然不影响运行，但是看起来不太美观,下面代碼是解決方案:

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

const router = new Router(
    {
        mode: 'history',
        routes: [{
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/unenabled',
            component: unenabled
        },
        {
            path: '/mainView',
            component: mainView,
            children: [
                { path: '/userMaintenance', component: userMaintenance },
                { path: '/roleMaintenance', component: roleMaintenance },
                { path: '/changePassword', component: changePassword },
                { path: '/auditLog', component: auditLog },
                { path: '/userEdit', component: userEdit },
                { path: '/addUser', component: addUser },
                { path: '/addRole', component: addRole },
                { path: '/roleEdit', component: roleEdit },
                ...managerRouters,
                ...recordRouters,
                ...reportRouters,
            ]
        }]
    }
)

router.beforeEach((to, from, next) => {
    if (to.meta.showInCrumb && !sessionStorage.getItem('token')) {
        next({ path: '/managerAuth', query: { nextUrl: to.fullPath } });
    } else {
        next();
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js